module.exports = __webpack_public_path__ + "img/image10.7649c976.jpg";